'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./login/login'));
    processInclude(require('./checkout/toggle-password'));
    processInclude(require('./account/resetPassword'));
    processInclude(require('./account/newPassword'));
    processInclude(require('./account/pluginLogin'));
    processInclude(require('capencyBase/capency/email/capemail'));
    processInclude(require('capency/capency/phone/capphone'));
    processInclude(require('capency/capency/address/capaddress'));
});
